<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade" [fullScreen]="true">
    <p style="color: white"> Please Wait Loading... </p>
</ngx-spinner> -->
<div class="col-md-4 col-md-offset-4">
    <div class=" panel panel-default ">
        <div class="panel-body ">
            <div class="text-center ">
                <h3><i class="fa fa-lock fa-4x " style="color: blue;"></i></h3>
                <h2 class="text-center ">Reset Password?</h2>
                <br>
                <form #myForm="ngForm" role="form" (ngSubmit)="resetPassword()">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="fa fa-lock" aria-hidden="true"></i></span>
                        </div>
                        <input type="password" class="form-control form-control-sm" placeholder="New Password"
                            [(ngModel)]="password1" name="password1" (blur)="validatePassword()" required>
                    </div>
                    <p class="text-danger font-size" *ngIf="result == false">
                        Example : John@123 <br>
                        Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters
                    </p>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="fa fa-lock" aria-hidden="true"></i></span>
                        </div>
                        <input type="password" class="form-control form-control-sm" placeholder="Confirm Password" [(ngModel)]="password2"
                            name="password2" required>
                    </div>
                    <p class="text-danger font-size" *ngIf="passwordMatch == false">
                        Passwords you entered didn't match.Try again
                    </p>
                    <br>
                    <div class="row">

                        <div class="col-6 offset-3">
                            <button type="submit" class="btn btn-sm btn-success" [disabled]="myForm.invalid || result == false">
                                Reset Password
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
